module.exports = __webpack_public_path__ + "img/deal-red.572c2586.svg";